<template>
  <div class="wrapper">
    <!-- 返回按钮 -->
    <div class="back-btn-box">
      <button-a
        class="goBackBtn"
        color="#707070"
        bgcolor="transparent"
        @click.native="$router.go(-1)"
      >
        <i class="el-icon-back"></i> 返回
      </button-a>
    </div>
    <!-- 属性面板 -->
    <div class="infomation white_box">
      <img class="user_picture" src="@/assets/icons/company@2x.png" alt />
      <div class="key-value">
        <div class="item">
          <div class="font_14_gray left">员工姓名</div>
          <div class="font_14_black right">{{ infodata.employeeName}}</div>
        </div>
        <div class="item" style="margin-bottom: 0;">
          <div class="font_14_gray left">证件类型</div>
          <div class="font_14_black right">{{ CardType }}</div>
        </div>
      </div>
      <div class="key-value">
        <div class="item">
          <div class="font_14_gray left">所属企业</div>
          <div class="font_14_black right">{{ infodata.customerId}}</div>
        </div>
        <div class="item" style="margin-bottom: 0;">
          <div class="font_14_gray left">证件号码</div>
          <div class="font_14_black right">{{ infodata.idCard}}</div>
        </div>
      </div>
    </div>
    <div class="contract white_box">
      <title-a padding="48" title="合同信息" />
      <div class="title_border" />
      <div class="session">
        <div class="session-title font_14_black">基本信息</div>
        <div class="session-content">
          <div class="key-value">
            <div class="item">
              <div class="font_14_gray left">合同甲方</div>
              <div class="font_14_black right">{{ infodata.partyA}}</div>
            </div>
            <div class="item">
              <div class="font_14_gray left">合同性质</div>
              <div class="font_14_black right">{{ infodata.contractNature}}</div>
            </div>
            <div class="item">
              <div class="font_14_gray left">合同类型</div>
              <div class="font_14_black right">{{ infodata.contractType}}</div>
            </div>
          </div>
          <div class="key-value">
            <div class="item">
              <div class="font_14_gray left">合同乙方</div>
              <div class="font_14_black right">{{ infodata.partyB}}</div>
            </div>
            <div class="item">
              <div class="font_14_gray left">用工单位</div>
              <div class="font_14_black right">{{ infodata.workCompany}}</div>
            </div>
            <div class="item">
              <div class="font_14_gray left">签约类型</div>
              <div class="font_14_black right">{{ infodata.signType}}</div>
            </div>
          </div>
        </div>
        <div class="session-title font_14_black">合同期限</div>
        <div class="session-content">
          <div class="key-value">
            <div class="item">
              <div class="font_14_gray left">合同期限</div>
              <div class="font_14_black right">{{ infodata.contractTime}}</div>
            </div>
            <div class="item">
              <div class="font_14_gray left">试用期限</div>
              <div class="font_14_black right">{{ getTryTime}}</div>
            </div>
          </div>
          <div class="key-value">
            <div class="item">
              <div class="font_14_gray left">期限类型</div>
              <div class="font_14_black right">{{ infodata.limitType}}</div>
            </div>
          </div>
        </div>
        <div class="session-title font_14_black">工作内容</div>
        <div class="session-content">
          <div class="key-value">
            <div class="item">
              <div class="font_14_gray left">工作岗位</div>
              <div class="font_14_black right">{{ infodata.job}}</div>
            </div>
            <div class="item">
              <div class="font_14_gray left">用工期限</div>
              <div class="font_14_black right">{{ infodata.timeLimit}}</div>
            </div>
          </div>
          <div class="key-value">
            <div class="item">
              <div class="font_14_gray left">工作地点</div>
              <div class="font_14_black right">{{ infodata.place}}</div>
            </div>
          </div>
        </div>
        <div class="session-title font_14_black">劳动报酬</div>
        <div class="session-content">
          <div class="key-value">
            <div class="item">
              <div class="font_14_gray left">试用薪资</div>
              <div class="font_14_black right">{{ infodata.oldSalary}}</div>
            </div>
            <div class="item">
              <div class="font_14_gray left">发薪日期</div>
              <div class="font_14_black right">{{ infodata.payDate}}</div>
            </div>
          </div>
          <div class="key-value">
            <div class="item">
              <div class="font_14_gray left">转正薪资</div>
              <div class="font_14_black right">{{ infodata.newSalary}}</div>
            </div>
          </div>
        </div>
        <div class="session-title font_14_black" v-show="infodata.attachmentId">附件信息</div>
        <div class="session-content" v-show="infodata.attachmentId">
          <div class="key-value">
            <div class="item" style="margin-bottom: 0;">
              <div
                class="font_14_gray left pdf"
                @click="downloadPdf(infodata.attachmentId, infodata.attachmentName)"
              >
                <img class="pdf_icon" src="@/assets/icons/pdf@2x.png" alt />
                <span style="color: #5c74f5">{{infodata.attachmentName}}</span>
              </div>
              <!-- <div class="font_14_black right pdf"></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Download } from "@/js/http.js";
import { Get } from "@/js/http.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      infodata: [],
      tryTime: ""
    };
  },
  watch: {},
  computed: {
    CardType() {
      let ct = this.infodata.idCardType;
      if (ct == 1) {
        return "身份证";
      } else if (ct == 2) {
        return "护照";
      } else if (ct == 3) {
        return "其他";
      } else {
        return "";
      }
    },
    getTryTime() {
      let tryt = this.tryTime;
      if (tryt.indexOf("0001-01-01") != -1) {
        return "";
      } else {
        return tryt;
      }
    }
  },
  methods: {
    getData() {
      let id = this.$route.params.id;

      Get(`api/v1/employee-contracts/${id}`)
        .then(res => {
          this.infodata = res.data;
          this.tryTime = res.data.tryTime;
        })
        .catch(() => {
        });
    },
    // 下载附件
    downloadPdf(id, title) {
      Download(
        `api/v1/customers/attachments/${id}`,
        {},
        title
      );
    }
  },
  created() {},
  mounted() {
    this.getData();
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 32px;
  // 属性面板
  .infomation {
    display: flex;
    align-items: center;
    padding: 30px 84px;
    margin-bottom: 32px;
    .user_picture {
      margin-right: 64px;
      width: 104px;
      height: 104px;
    }
    .right {
      width: 240px;
    }
  }
  .contract {
    .session {
      padding: 55px 78px;
      .session-title {
        margin-bottom: 40px;
      }
      .session-content {
        display: flex;
      }
    }
  }
}

// 键值对
.key-value {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: stretch;
  margin-right: 50px;
  &:last-child {
    margin-right: 0;
  }
  .item {
    display: flex;
    margin-bottom: 32px;
  }
  .left {
    width: 84px;
    margin-right: 50px;
    text-align: right;
  }
  .right {
    width: 300px;
  }
  .key {
    margin-right: 50px;
    p {
      text-align: right;
    }
  }
  p {
    margin-bottom: 32px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
.infomation .key-value {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.contract .key-value {
  margin-bottom: 8px;
}
.left.pdf {
  display: flex;
  align-items: center;
  width: auto;
  margin-left: 40px;
  text-align: left;
  cursor: pointer;
  img {
    margin-right: 15px;
  }
}

.back-btn-box {
  margin-bottom: 32px;
}
.goBackBtn {
  font-size: 16px !important;
  border: none !important;
  border-color: transparent !important;
}
</style>